/**
 * The environment configuration object for development environment.
 */
export const environment = {
    production: false,
    name: 'dev'
};
